module.exports = __webpack_public_path__ + "img/f8706e8.jpg";